import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Invite() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(apiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/auth/invite/${token}/accept`, { password });
      login(data);
      navigate("/accueil");
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-in">
        <p className="font-display font-bold text-4xl lowercase tracking-tight text-center mb-8">kavizio</p>
        <form onSubmit={submit} className="kcard p-6 space-y-4">
          <h1 className="font-display font-bold text-xl">Invitation</h1>
          {error && <p data-testid="invite-error" className="text-sm text-[#B4432F] bg-[#F6E3DF] rounded-xl px-3 py-2">{error}</p>}
          {info && (
            <>
              <p className="text-sm text-gray-600">
                Bonjour <span className="font-semibold">{info.name}</span>, vous êtes invité(e) à rejoindre{" "}
                <span className="font-semibold">{info.company_name}</span> en tant que <span className="font-semibold">{info.role}</span>.
                Choisissez votre mot de passe personnel — vous seul(e) le connaissez.
              </p>
              <input data-testid="invite-password-input" className="kinput" type="password" placeholder="Votre mot de passe (6 caractères min)"
                value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
              <button data-testid="invite-submit-btn" className="btn-amber w-full py-3" disabled={busy}>
                {busy ? "Activation..." : "Activer mon compte"}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
